"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StyledWarning = _styledComponents["default"].p.withConfig({
  displayName: "Warning__StyledWarning",
  componentId: "sc-1bp9yfz-0"
})(["", ""], function (props) {
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    typography = _props$theme.typography,
    spacing = _props$theme.spacing;
  return (0, _styledComponents.css)(["color:", ";font-size:", ";line-height:", ";padding:0 ", ";"], palette.validation.warning, typography.size.table, typography.lineHeight.misc, spacing.tiny);
});
var Warning = function Warning(_ref) {
  var message = _ref.message,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledWarning, {
    className: className
  }, message);
};
Warning.defaultProps = {
  className: ''
};
Warning.propTypes = {
  message: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
Warning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Warning",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "message": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Warning;
exports["default"] = _default;